





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';


@Component({
  components: {
  }
})
export default class UserAgent extends Vue {
  @Prop() 
  conditions: any;

  @Prop({ default: false })
  withCustomArea: boolean;

  mounted() {
    if (!this.conditions.userAgent) {
      this.$set(this.conditions, 'userAgent', {
        predicate: this.predicate,
        values: []
      });
    } else {
      if (this.conditions.userAgent.predicate) {
        this.predicate = this.conditions.userAgent.predicate;
      }
    }
  }

  get tabs() {
    return [
      {
        label: this.t('From List'),
        key: 'fromList',
        icon: 'fas fa-list',
      },
      {
        label: this.t('Custom'),
        key: 'custom',
        icon: 'fas fa-pen',
      },
    ]
  }

  changeCustomField({ target }) {
    this.selected = _.uniq(target.value.split('\n').filter(item => !!item))
  }

  get customUserAgent() {
    return this.selected.join('\n')
  }

  get predicate() {
    if (!this.conditions.userAgent || !this.conditions.userAgent.predicate)
      return 'CONTAINS';

    return this.conditions.userAgent.predicate;
  }

  set predicate(value: string) {
    this.$set(this.conditions.userAgent, 'predicate', value);
  }

  get selected() {
    if (!this.conditions.userAgent)
      return [];

    return this.conditions.userAgent.values.map((v: string) => !v ? `[${this.t('Empty Value')}]` : v);
  }

  set selected(value: string[]) {
    let result = value.map((e: string) => e === `[${this.t('Empty Value')}]` ? '' : e);
    this.$set(this.conditions.userAgent, 'values', result);
  }

  get includeEmpty() {
    if (!this.conditions.userAgent)
      return false;

    return this.conditions.userAgent.values.some((v: string) => !v);
  }

  set includeEmpty(value: boolean) {
    if (value) {
      this.conditions.userAgent.values.push('');
    } else {
      this.conditions.userAgent.values.splice(this.conditions.userAgent.values.indexOf(''), 1);
    }
  }
}
